// Custom SVG Icons Components
import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const DownArrowIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = '#495057', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 60 60" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="60" height="60" rx="8" fill="#f8f9fa" stroke="#e9ecef" strokeWidth="1"/>
    <path 
      d="M20 22 L30 32 L40 22" 
      stroke={color} 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      fill="none"
    />
    <path 
      d="M30 15 L30 32" 
      stroke={color} 
      strokeWidth="2.5" 
      strokeLinecap="round"
    />
  </svg>
);

export const UpArrowIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = '#495057', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 60 60" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="60" height="60" rx="8" fill="#f8f9fa" stroke="#e9ecef" strokeWidth="1"/>
    <path 
      d="M20 38 L30 28 L40 38" 
      stroke={color} 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      fill="none"
    />
    <path 
      d="M30 45 L30 28" 
      stroke={color} 
      strokeWidth="2.5" 
      strokeLinecap="round"
    />
  </svg>
);

export const CheckboxIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = '#28a745', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 60 60" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="60" height="60" rx="8" fill="#f8f9fa" stroke="#e9ecef" strokeWidth="1"/>
    <rect x="18" y="18" width="24" height="24" rx="4" fill="white" stroke="#6c757d" strokeWidth="2"/>
    <path 
      d="M22 30 L26 34 L38 22" 
      stroke={color} 
      strokeWidth="2.5" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      fill="none"
    />
  </svg>
);

export const TagIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = '#fd7e14', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 60 60" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0" y="0" width="60" height="60" rx="8" fill="#f8f9fa" stroke="#e9ecef" strokeWidth="1"/>
    <path 
      d="M18 28 L32 18 L42 18 L42 28 L32 38 Z" 
      fill={color} 
      stroke="#e85d04" 
      strokeWidth="1.5" 
      strokeLinejoin="round"
    />
    <circle cx="36" cy="23" r="2" fill="white"/>
  </svg>
);

// GitHub-style down and up arrows (thin stroke-based chevrons)
export const SimpleDownArrowIcon: React.FC<IconProps> = ({
  size = 16,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline points="5 7.5 10 12.5 15 7.5"/>
  </svg>
);

export const SimpleUpArrowIcon: React.FC<IconProps> = ({
  size = 16,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline points="5 12.5 10 7.5 15 12.5"/>
  </svg>
);

// Double chevron icons for expand/collapse all
export const DoubleDownArrowIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline points="5 5 10 10 15 5"/>
    <polyline points="5 10 10 15 15 10"/>
  </svg>
);

export const DoubleUpArrowIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline points="5 15 10 10 15 15"/>
    <polyline points="5 10 10 5 15 10"/>
  </svg>
);

export const SimpleCheckboxIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = '#28a745', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 20 20" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2" y="2" width="16" height="16" rx="3" fill="white" stroke="#6c757d" strokeWidth="1.5"/>
    <path 
      d="M6 10 L8.5 12.5 L14 7" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      fill="none"
    />
  </svg>
);

export const SimpleTagIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = '#fd7e14', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 20 20" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      d="M2 10 L7.5 2 L18 2 L18 10.5 L7.5 18 Z" 
      fill={color} 
      stroke="#e85d04" 
      strokeWidth="1" 
      strokeLinejoin="round"
    />
    <circle cx="14" cy="6.5" r="1.8" fill="white"/>
  </svg>
);

export const TrashIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = '#656d76', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
  >
    <path 
      fillRule="evenodd" 
      d="M11 1.75V3h2.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75ZM4.496 6.675l.66 6.6a.25.25 0 0 0 .249.225h5.19a.25.25 0 0 0 .249-.225l.66-6.6a.75.75 0 0 1 1.492.149l-.66 6.6A1.748 1.748 0 0 1 10.595 15h-5.19a1.75 1.75 0 0 1-1.741-1.575l-.66-6.6a.75.75 0 1 1 1.492-.15ZM6.5 1.75V3h3V1.75a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25Z"
    />
  </svg>
);

export const AddIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = '#1a7f37', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
  >
    <path 
      fillRule="evenodd" 
      d="M7.75 2a.75.75 0 0 1 .75.75V7h4.25a.75.75 0 0 1 0 1.5H8.5v4.25a.75.75 0 0 1-1.5 0V8.5H2.75a.75.75 0 0 1 0-1.5H7V2.75A.75.75 0 0 1 7.75 2Z"
    />
  </svg>
);

export const CheckIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = '#1a7f37', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 16 16" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
  >
    <path 
      fillRule="evenodd" 
      d="M13.78 4.22a.75.75 0 0 1 0 1.06l-7.25 7.25a.75.75 0 0 1-1.06 0L2.22 9.28a.751.751 0 0 1 .018-1.042.751.751 0 0 1 1.042-.018L6 10.94l6.72-6.72a.75.75 0 0 1 1.06 0Z"
    />
  </svg>
);

export const WorkbenchIcon: React.FC<IconProps> = ({ 
  size = 20, 
  color = '#0969da', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Workbench table/desk */}
    <rect 
      x="3" 
      y="12" 
      width="18" 
      height="3" 
      rx="1" 
      stroke={color} 
      strokeWidth="2" 
      fill="#f6f8fa"
    />
    {/* Table legs */}
    <line 
      x1="5" 
      y1="15" 
      x2="5" 
      y2="20" 
      stroke={color} 
      strokeWidth="2"
    />
    <line 
      x1="19" 
      y1="15" 
      x2="19" 
      y2="20" 
      stroke={color} 
      strokeWidth="2"
    />
    {/* Tools on workbench */}
    {/* Code bracket symbols */}
    <path 
      d="M7 7L5 9L7 11" 
      stroke={color} 
      strokeWidth="2" 
      fill="none"
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M17 7L19 9L17 11" 
      stroke={color} 
      strokeWidth="2" 
      fill="none"
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    {/* Central gear/cog representing development tools */}
    <circle 
      cx="12" 
      cy="8.5" 
      r="2.5" 
      stroke={color} 
      strokeWidth="1.5" 
      fill="none"
    />
    <circle 
      cx="12" 
      cy="8.5" 
      r="1" 
      fill={color}
    />
    {/* Gear teeth */}
    <line x1="12" y1="4.5" x2="12" y2="5.5" stroke={color} strokeWidth="1"/>
    <line x1="12" y1="11.5" x2="12" y2="12.5" stroke={color} strokeWidth="1"/>
    <line x1="15.5" y1="8.5" x2="16.5" y2="8.5" stroke={color} strokeWidth="1"/>
    <line x1="7.5" y1="8.5" x2="8.5" y2="8.5" stroke={color} strokeWidth="1"/>
  </svg>
);

// Keep SandboxIcon for backward compatibility (alias to WorkbenchIcon)
export const SandboxIcon: React.FC<IconProps> = WorkbenchIcon;

// GitHub-style section icons
export const DocumentIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Document with folded corner */}
    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
  </svg>
);

export const CheckCircleIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Simple checkmark without circle */}
    <path d="M5 13l4 4L19 7"/>
  </svg>
);

export const CodeIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* </> code brackets with slash */}
    <polyline points="8 18 3 12 8 6"/>
    <polyline points="16 6 21 12 16 18"/>
    <line x1="14" y1="4" x2="10" y2="20"/>
  </svg>
);

export const RobotIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = 'currentColor', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Robot head/body - made bigger */}
    <rect x="4" y="6" width="16" height="13" rx="2.5" fill="currentColor"/>
    {/* Eyes with dark outline */}
    <circle cx="8.5" cy="11.5" r="1.8" fill="white" stroke="#333" strokeWidth="0.3"/>
    <circle cx="15.5" cy="11.5" r="1.8" fill="white" stroke="#333" strokeWidth="0.3"/>
    {/* Mouth */}
    <rect x="9.5" y="16" width="5" height="1.2" rx="0.6" fill="white"/>
    {/* Antenna */}
    <rect x="11" y="4" width="2" height="2.5" rx="1" fill="currentColor"/>
    {/* Antenna dots */}
    <circle cx="10" cy="2.5" r="1" fill="currentColor"/>
    <circle cx="14" cy="2.5" r="1" fill="currentColor"/>
  </svg>
);

// AI Chat Icon - Magic sparkle/star burst design
export const AIChatIcon: React.FC<IconProps> = ({
  size = 18,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Central large star/sparkle - BIGGER */}
    <path
      d="M12 1L14 8L21 10L14 12L12 19L10 12L3 10L10 8L12 1Z"
      fill="url(#sparkleGradient1)"
    />
    <path
      d="M12 3L13.2 8.5L18.5 10L13.2 11.5L12 17L10.8 11.5L5.5 10L10.8 8.5L12 3Z"
      fill="white"
      opacity="0.8"
    />

    {/* Small sparkle - top right - BIGGER */}
    <path
      d="M18 4L18.7 6.5L21 7L18.7 7.5L18 10L17.3 7.5L15 7L17.3 6.5L18 4Z"
      fill="#FFD700"
    />
    <circle cx="18" cy="7" r="0.8" fill="white" />

    {/* Small sparkle - bottom left - BIGGER */}
    <path
      d="M6 14L6.7 16.5L9 17L6.7 17.5L6 20L5.3 17.5L3 17L5.3 16.5L6 14Z"
      fill="#A78BFA"
    />
    <circle cx="6" cy="17" r="0.8" fill="white" />

    {/* Small sparkle - top left - BIGGER */}
    <path
      d="M5 5L5.5 6.8L7.2 7.3L5.5 7.8L5 9.5L4.5 7.8L2.8 7.3L4.5 6.8L5 5Z"
      fill="#06B6D4"
    />

    {/* Small sparkle - bottom right - BIGGER */}
    <path
      d="M19 15L19.5 16.8L21.2 17.3L19.5 17.8L19 19.5L18.5 17.8L16.8 17.3L18.5 16.8L19 15Z"
      fill="#2563EB"
    />

    {/* AI text badge - BIGGER */}
    <text
      x="12"
      y="23.5"
      textAnchor="middle"
      fill="white"
      fontSize="8"
      fontWeight="bold"
      fontFamily="system-ui, -apple-system, sans-serif"
    >
      AI
    </text>

    {/* Gradients */}
    <defs>
      <linearGradient id="sparkleGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FFD700" />
        <stop offset="50%" stopColor="#A78BFA" />
        <stop offset="100%" stopColor="#06B6D4" />
      </linearGradient>
    </defs>
  </svg>
);

export const UserIcon: React.FC<IconProps> = ({ 
  size = 24, 
  color = 'currentColor', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* User head */}
    <circle cx="12" cy="8" r="4" fill="currentColor"/>
    {/* User body */}
    <path d="M6 21c0-3.9 2.7-7 6-7s6 3.1 6 7" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

export const MicrophoneIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = 'currentColor', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z"/>
    <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
  </svg>
);

export const StopIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = 'currentColor', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="6" width="12" height="12" rx="2" fill="currentColor"/>
  </svg>
);

export const PlayIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = 'currentColor', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <polygon points="8,5 19,12 8,19" fill="currentColor"/>
  </svg>
);

export const DeleteIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = 'currentColor', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    className={className}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"/>
  </svg>
);

// New icons for tag visibility toggle
export const TagsVisibleIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = 'currentColor', 
  className = '' 
}) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Multiple tags icon to show tags are visible */}
    <g>
      {/* First tag (twice as big as before) */}
      <path 
        d="M0 24L14 4L36 4L36 24L14 44Z" 
        fill={color}
        opacity="0.6"
      />
      <circle cx="28" cy="12" r="4" fill="white"/>
      
      {/* Second tag (offset, twice as big as before) */}
      <path 
        d="M12 26L26 6L48 6L48 26L26 46Z" 
        fill={color}
      />
      <circle cx="40" cy="14" r="4" fill="white"/>
    </g>
  </svg>
);

export const TagsHiddenIcon: React.FC<IconProps> = ({
  size = 16,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Single tag with slash through it */}
    <g>
      {/* Tag shape (twice as big as before) */}
      <path
        d="M2 24L16 2L44 2L44 24L16 46Z"
        fill={color}
        opacity="0.5"
      />
      <circle cx="36" cy="10" r="5" fill="white" opacity="0.7"/>

      {/* Diagonal line indicating "hidden" */}
      <line
        x1="2"
        y1="46"
        x2="46"
        y2="2"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

// AIPrep Logo Icon - Hand with AI sparkles
export const AIPrepLogoIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
  >
    {/* Hand shape - cupped palm facing up */}
    <path
      d="M15 75
         C5 70 5 60 15 55
         L25 50
         C30 48 35 50 38 55
         L45 65
         C50 72 60 72 70 65
         L85 50
         C95 42 95 55 85 65
         L70 80
         C55 95 25 95 15 75 Z"
      fill={color}
    />

    {/* Main large sparkle/star */}
    <path
      d="M50 5
         L54 22
         L70 28
         L54 34
         L50 50
         L46 34
         L30 28
         L46 22 Z"
      fill={color}
    />

    {/* Small sparkle - right */}
    <path
      d="M75 15
         L77 22
         L84 24
         L77 26
         L75 33
         L73 26
         L66 24
         L73 22 Z"
      fill={color}
    />

    {/* Small dot - top */}
    <circle cx="60" cy="8" r="3" fill={color} />
  </svg>
);

// LeetCode Icon - external link arrow icon
export const LeetCodeIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#57606a',  // GitHub-style dark gray
  className = ''
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke={color}
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* External link icon - box with arrow pointing to top-right */}
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);